import {
    Button, CircularProgress, CssBaseline, Dialog, DialogContent,
    Grid, Snackbar, Tooltip, Typography, useMediaQuery, useTheme, Switch,
    FormControlLabel
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import React, { useEffect, useState } from "react";
import MuiDialogTitle from "@mui/material/DialogTitle";
import IconSaveOrUpdate from "@mui/icons-material/SaveOutlined";
import IconRestore from "@mui/icons-material/AutorenewOutlined";
import { Alert } from "@mui/lab";
import CreateIcon from "@mui/icons-material/Add";
import ViewIcon from "@mui/icons-material/Visibility";
import ClearIcon from "@mui/icons-material/Clear";
import InfoIcon from "@mui/icons-material/Info";
import {
    Checkbox, Divider, FormControl, FormHelperText,
    InputLabel, TextField,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import useStyles from "../../../common/CommonStyle/CommonStyle";
import { Autocomplete } from "@mui/lab";
import { withStyles } from "@mui/styles";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomBreadCrumb from "../../../common/CustomBreadCrumb";
import TimeZoneCombo from "../../../../CustomSchedulerTab/SchedulerTabCombos/TimeZoneCombos";
import { CommonService } from '../../../../services';
import { GlobalEdiApiConstants } from '../../../../Constants/GlobalEdiApiConstants';

const everyHourValue = [
    { id: 1, value: "0", time: "0AM" },
    { id: 2, value: "1", time: "1AM" },
    { id: 3, value: "2", time: "2AM" },
    { id: 4, value: "3", time: "3AM" },
    { id: 5, value: "4", time: "4AM" },
    { id: 6, value: "5", time: "5AM" },
    { id: 7, value: "6", time: "6AM" },
    { id: 8, value: "7", time: "7AM" },
    { id: 9, value: "8", time: "8AM" },
    { id: 10, value: "9", time: "9AM" },
    { id: 11, value: "10", time: "10AM" },
    { id: 12, value: "11", time: "11AM" },
    { id: 13, value: "12", time: "12AM" },
    { id: 14, value: "13", time: "1PM" },
    { id: 15, value: "14", time: "2PM" },
    { id: 16, value: "15", time: "3PM" },
    { id: 17, value: "16", time: "4PM" },
    { id: 18, value: "17", time: "5PM" },
    { id: 19, value: "18", time: "6PM" },
    { id: 20, value: "19", time: "7PM" },
    { id: 21, value: "20", time: "8PM" },
    { id: 22, value: "21", time: "9PM" },
    { id: 23, value: "22", time: "10PM" },
    { id: 24, value: "23", time: "11PM" },
];

const everyMinuteValue = [
    { id: 1, value: "0", minute: "0" }, { id: 2, value: "1", minute: "1" },
    { id: 3, value: "2", minute: "2" }, { id: 4, value: "3", minute: "3" },
    { id: 5, value: "4", minute: "4" }, { id: 6, value: "5", minute: "5" },
    { id: 7, value: "6", minute: "6" }, { id: 8, value: "7", minute: "7" },
    { id: 9, value: "8", minute: "8" }, { id: 10, value: "9", minute: "9" },
    { id: 11, value: "10", minute: "10" }, { id: 12, value: "11", minute: "11" },
    { id: 13, value: "12", minute: "12" }, { id: 14, value: "13", minute: "13" },
    { id: 15, value: "14", minute: "14" }, { id: 16, value: "15", minute: "15" },
    { id: 17, value: "16", minute: "16" }, { id: 18, value: "17", minute: "17" },
    { id: 19, value: "18", minute: "18" }, { id: 20, value: "19", minute: "19" },
    { id: 21, value: "20", minute: "20" }, { id: 22, value: "21", minute: "21" },
    { id: 23, value: "22", minute: "22" }, { id: 24, value: "23", minute: "23" },
    { id: 25, value: "24", minute: "24" }, { id: 26, value: "25", minute: "25" },
    { id: 27, value: "26", minute: "26" }, { id: 28, value: "27", minute: "27" },
    { id: 29, value: "28", minute: "28" }, { id: 30, value: "29", minute: "29" },
    { id: 31, value: "30", minute: "30" }, { id: 32, value: "31", minute: "31" },
    { id: 33, value: "32", minute: "32" }, { id: 34, value: "33", minute: "33" },
    { id: 35, value: "34", minute: "34" }, { id: 36, value: "35", minute: "35" },
    { id: 37, value: "36", minute: "36" }, { id: 38, value: "37", minute: "37" },
    { id: 39, value: "38", minute: "38" }, { id: 40, value: "39", minute: "39" },
    { id: 41, value: "40", minute: "40" }, { id: 42, value: "41", minute: "41" },
    { id: 43, value: "42", minute: "42" }, { id: 44, value: "43", minute: "43" },
    { id: 45, value: "44", minute: "44" }, { id: 46, value: "45", minute: "45" },
    { id: 47, value: "46", minute: "46" }, { id: 48, value: "47", minute: "47" },
    { id: 49, value: "48", minute: "48" }, { id: 50, value: "49", minute: "49" },
    { id: 51, value: "50", minute: "50" }, { id: 52, value: "51", minute: "51" },
    { id: 53, value: "52", minute: "52" }, { id: 54, value: "53", minute: "53" },
    { id: 55, value: "54", minute: "54" }, { id: 56, value: "55", minute: "55" },
    { id: 57, value: "56", minute: "56" }, { id: 58, value: "57", minute: "57" },
    { id: 59, value: "58", minute: "58" }, { id: 60, value: "59", minute: "59" },
    { id: 61, value: "*/1", minute: "1" }, { id: 62, value: "*/2", minute: "2" },
    { id: 63, value: "*/3", minute: "3" }, { id: 64, value: "*/4", minute: "4" },
    { id: 65, value: "*/5", minute: "5" }, { id: 66, value: "*/6", minute: "6" },
    { id: 67, value: "*/7", minute: "7" }, { id: 68, value: "*/8", minute: "8" },
    { id: 69, value: "*/9", minute: "9" }, { id: 70, value: "*/10", minute: "10" },
    { id: 71, value: "*/15", minute: "15" }, { id: 72, value: "*/20", minute: "20" },
    { id: 73, value: "*/30", minute: "30" }, { id: 74, value: "*/45", minute: "45" },
];

const everyDayValue = [
    { id: 1, value: "1", ordinals: "1st" }, { id: 2, value: "2", ordinals: "2nd" },
    { id: 3, value: "3", ordinals: "3rd" }, { id: 4, value: "4", ordinals: "4th" },
    { id: 5, value: "5", ordinals: "5th" }, { id: 6, value: "6", ordinals: "6th" },
    { id: 7, value: "7", ordinals: "7th" }, { id: 8, value: "8", ordinals: "8th" },
    { id: 9, value: "9", ordinals: "9th" }, { id: 10, value: "10", ordinals: "10th" },
    { id: 11, value: "11", ordinals: "11th" }, { id: 12, value: "12", ordinals: "12th" },
    { id: 13, value: "13", ordinals: "13th" }, { id: 14, value: "14", ordinals: "14th" },
    { id: 15, value: "15", ordinals: "15th" }, { id: 16, value: "16", ordinals: "16th" },
    { id: 17, value: "17", ordinals: "17th" }, { id: 18, value: "18", ordinals: "18th" },
    { id: 19, value: "19", ordinals: "19th" }, { id: 20, value: "20", ordinals: "20th" },
    { id: 21, value: "21", ordinals: "21st" }, { id: 22, value: "22", ordinals: "22nd" },
    { id: 23, value: "23", ordinals: "23rd" }, { id: 24, value: "24", ordinals: "24th" },
    { id: 25, value: "25", ordinals: "25th" }, { id: 26, value: "26", ordinals: "26th" },
    { id: 27, value: "27", ordinals: "27th" }, { id: 28, value: "28", ordinals: "28th" },
    { id: 29, value: "29", ordinals: "29th" }, { id: 30, value: "30", ordinals: "30th" },
    { id: 31, value: "31", ordinals: "31st" },
];

const everyMonthValue = [
    { id: "1", value: "January" }, { id: "2", value: "February" },
    { id: "3", value: "March" }, { id: "4", value: "April" },
    { id: "5", value: "May" }, { id: "6", value: "June" },
    { id: "7", value: "July" }, { id: "8", value: "August" },
    { id: "9", value: "September" }, { id: "10", value: "October" },
    { id: "11", value: "November" }, { id: "12", value: "December" },
];

const everyWeekValue = [
    { id: "1", value: "Monday" }, { id: "2", value: "Tuesday" },
    { id: "3", value: "Wednesday" }, { id: "4", value: "Thursday" },
    { id: "5", value: "Friday" }, { id: "6", value: "Saturday" },
    { id: "7", value: "Sunday" },
];

const styles = (theme) => ({
    root: { margin: 0, padding: theme.spacing(1) },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disabletypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
        </MuiDialogTitle>
    );
});

const DialogActions = withStyles((theme) => ({
    root: { margin: 0, padding: theme.spacing(1) },
}))(MuiDialogActions);

function CustomValuationSchedulerTab(props) {
    const theme = useTheme();
    const classes = useStyles();
    const intl = useIntl();

    const {
        open,
        onClose,
        mode,
        emailMessageConfigToBeEdited,
        // 'alertEmail' | 'evaluationConfirmationEmail'
        frequencyType,
        // callback: (frequencyType, cronExp, timeZone) => void
        onSchedulerSave,
    } = props;
    console.log("emailMessageConfigToBeEdited", emailMessageConfigToBeEdited);

    const getInitialFrequency = () => {
        if (!emailMessageConfigToBeEdited) return '* * * * *';
        const raw =
            frequencyType === 'alertEmail'
                ? emailMessageConfigToBeEdited.alertEmailFrequency
                : emailMessageConfigToBeEdited.evaluationConfirmationEmailFrequency;
        return raw && raw.trim() !== '' ? raw.trim() : '* * * * *';
    };

    const getInitialTimeZone = () => {
        if (!emailMessageConfigToBeEdited) return '';

        return frequencyType === 'alertEmail'
            ? emailMessageConfigToBeEdited.alertTimeZone
            : emailMessageConfigToBeEdited.evaluationTimeZone;
    };
    const initialTimeZone = getInitialTimeZone();

    const initialFrequency = getInitialFrequency();

    // ─── Parse initial cron expression into parts ───────────────────────────────
    const defaultParts = initialFrequency.split(' ');
    const defaultMinuteParts = defaultParts[0] ? defaultParts[0].split(',') : [];
    const defaultHourParts = defaultParts[1] ? defaultParts[1].split(',') : [];
    const defaultDayParts = defaultParts[2] ? defaultParts[2].split(',') : [];
    const defaultMonthParts = defaultParts[3] ? defaultParts[3].split(',') : [];
    const defaultWeekParts = defaultParts[4] ? defaultParts[4].split(',') : [];

    const [isSubmitting, setIsSubmitting] = useState(false);

    const cronMinuteValueLoad = everyMinuteValue.filter(item =>
        defaultMinuteParts.includes(item.value)
    );
    const cronHourValueLoad = everyHourValue.filter(item =>
        defaultHourParts.includes(item.value)
    );
    const cronDayValueLoad = everyDayValue.filter(item =>
        defaultDayParts.includes(item.value)
    );
    const cronMonthValueLoad = everyMonthValue.filter(item =>
        defaultMonthParts.includes(item.id)
    );
    const cronWeekValueLoad = everyWeekValue.filter(item =>
        defaultWeekParts.includes(item.id)
    );

    // ─── State ───────────────────────────────────────────────────────────────────
    const smallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [disabledForReadMode, setDisabledForReadMode] = useState(false);
    const [disableRestoreButton, isRestoreButtonDisabled] = useState(false);
    const [disableSaveOrUpdateButton, setSaveOrUpdateButtonDisabled] = useState(false);
    const [saveOrUpdateButtonLabel, setSaveOrUpdateButtonLabel] = useState('');
    const [checked, setChecked] = useState(true);
    const [isCronDayFieldDisable, setIsCronDayFieldDisable] = useState(false);
    const [isWeekDayFieldDisable, setIsCronWeekFieldDisable] = useState(false);
    const [cronExp, setCronExp] = useState(initialFrequency);
    const [currentState, setCurrentState] = useState('Executes: every minute');
    const [minuteValue, setMinuteValue] = useState(cronMinuteValueLoad);
    const [hourValue, setHourValue] = useState(cronHourValueLoad);
    const [dayValue, setDayValue] = useState(cronDayValueLoad);
    const [monthValue, setMonthValue] = useState(cronMonthValueLoad);
    const [weekValue, setWeekValue] = useState(cronWeekValueLoad);
    const [timeZoneValue, setTimeZoneValue] = useState({ value: initialTimeZone });


    const [isActive, setIsActive] = useState(
        frequencyType === 'alertEmail'
            ? !!emailMessageConfigToBeEdited?.alertActive
            : !!emailMessageConfigToBeEdited?.evaluationActive
    );


    const [alertBoxState, setAlertBoxState] = useState({
        openAlert: false, vertical: 'top', horizontal: 'center', message: '', severity: '',
    });
    const { vertical, horizontal, openAlert, message, severity } = alertBoxState;

    const handleCloseAlert = () => setAlertBoxState({ ...alertBoxState, openAlert: false });

    // ─── React Hook Form ─────────────────────────────────────────────────────────
    const { handleSubmit, formState: { errors, isDirty, isValid }, control, reset, setValue } = useForm({
        mode: 'all',
        reValidateMode: 'all',
        defaultValues: { frequency: initialFrequency, timeZone: initialTimeZone },
    });

    const pageLabelsConstantsAndMessages = {
        name: { frequency: 'frequency', timeZone: 'timeZone' },
    };

    // ─── Breadcrumb ──────────────────────────────────────────────────────────────
    const componentList = [
        { path: null, name: 'Customs Valuation Email Config' },
        {
            path: null,
            name: frequencyType === 'alertEmail' ? 'Alert Email Scheduler' : 'Evaluation Confirmation Email Scheduler',
            iconName: mode === 'create' ? CreateIcon : mode === 'edit' ? EditIcon : ViewIcon,
        },
    ];

    // ─── Mode setup ──────────────────────────────────────────────────────────────
    useEffect(() => {
        if (mode === 'create') {
            setSaveOrUpdateButtonLabel(<FormattedMessage id="common.button.save" defaultMessage="Save" />);
            isRestoreButtonDisabled(false);
            setSaveOrUpdateButtonDisabled(false);
            setDisabledForReadMode(false);
        } else if (mode === 'edit') {
            setSaveOrUpdateButtonLabel(<FormattedMessage id="common.button.update" defaultMessage="Update" />);
            isRestoreButtonDisabled(false);
            setSaveOrUpdateButtonDisabled(false);
            setDisabledForReadMode(false);
            setCronExp(initialFrequency);
            setTimeZoneValue({
                value: frequencyType === 'alertEmail'
                    ? emailMessageConfigToBeEdited?.alertTimeZone
                    : emailMessageConfigToBeEdited?.evaluationTimeZone
            });

            setMinuteValue(cronMinuteValueLoad);
            setHourValue(cronHourValueLoad);
            setDayValue(cronDayValueLoad);
            setMonthValue(cronMonthValueLoad);
            setWeekValue(cronWeekValueLoad);
        } else if (mode === 'read') {
            setSaveOrUpdateButtonLabel(<FormattedMessage id="common.button.update" defaultMessage="Update" />);
            isRestoreButtonDisabled(true);
            setSaveOrUpdateButtonDisabled(true);
            setDisabledForReadMode(true);
            setCronExp(initialFrequency);
            setTimeZoneValue({
                value: frequencyType === 'alertEmail'
                    ? emailMessageConfigToBeEdited?.alertTimeZone
                    : emailMessageConfigToBeEdited?.evaluationTimeZone
            });
            setMinuteValue(cronMinuteValueLoad);
            setHourValue(cronHourValueLoad);
            setDayValue(cronDayValueLoad);
            setMonthValue(cronMonthValueLoad);
            setWeekValue(cronWeekValueLoad);
        }
    }, [mode, emailMessageConfigToBeEdited, frequencyType]);

    // ─── Mutual exclusion: day vs weekday ────────────────────────────────────────
    useEffect(() => {
        if (weekValue.length !== 0) {
            setIsCronDayFieldDisable(true);
        } else if (dayValue.length !== 0) {
            setIsCronWeekFieldDisable(true);
        } else {
            setIsCronDayFieldDisable(false);
            setIsCronWeekFieldDisable(false);
        }
    }, [weekValue, dayValue]);

    // ─── Build cron expression & human-readable string whenever selectors change ─
    useEffect(() => {
        const buildCronPart = (arr, key, fallback) => {
            const vals = arr.map(item => item[key]);
            return vals.length === 0 ? [fallback] : vals;
        };

        const cronMinutes = buildCronPart(minuteValue, 'value', '*');
        const cronHours = buildCronPart(hourValue, 'value', '*');
        const cronDays = buildCronPart(dayValue, 'value', '*');
        const cronMonths = buildCronPart(monthValue, 'id', '*');
        const cronWeeks = buildCronPart(weekValue, 'id', '*');

        const cronExpString = [
            cronMinutes.join(','),
            cronHours.join(','),
            cronDays.join(','),
            cronMonths.join(','),
            cronWeeks.join(','),
        ].join(' ');

        // Human-readable
        const hrMinutes = minuteValue.length === 0
            ? 'every minute'
            : (() => {
                const hasStar = minuteValue.some(m => m.value.includes('*'));
                const labels = minuteValue.map(m => m.minute);
                return hasStar ? `every ${labels.join(',')} minute(s)` : `at minute ${labels.join(',')}`;
            })();

        const hrHours = hourValue.length === 0
            ? 'every hour'
            : `at ${hourValue.map(h => h.time).join(',')}`;

        const hrWeeks = weekValue.length > 0 ? `on ${weekValue.map(w => w.value).join(',')}` : '';
        const hrDays = dayValue.length > 0
            ? `on the ${dayValue.map(d => d.ordinals).join(',')}`
            : weekValue.length === 0 ? 'every day' : '';

        const hrMonths = monthValue.length === 0
            ? 'every month'
            : `in ${monthValue.map(m => m.value).join(',')}`;

        const currentExeString = ['Execute:', hrMonths, hrDays, hrWeeks, hrHours, hrMinutes]
            .filter(Boolean).join(' ');

        if (mode === 'edit') {
            setValue(pageLabelsConstantsAndMessages.name.frequency, cronExpString, {
                shouldValidate: true, shouldDirty: true,
            });
        }
        setCronExp(cronExpString);
        setCurrentState(currentExeString);
    }, [hourValue, minuteValue, weekValue, monthValue, dayValue]);

    // ─── Handlers ────────────────────────────────────────────────────────────────
    const handleChangeForHourCron = (_, values) => setHourValue(values);
    const handleChangeForWeekCron = (_, values) => setWeekValue(values);
    const handleChangeForMonthCron = (_, values) => setMonthValue(values);
    const handleChangeForDayCron = (_, values) => setDayValue(values);
    const handleChangeForMinuteCron = (_, values) => setMinuteValue(values);
    const handleChange = (event) => setChecked(event.target.checked);

    // ─── Reset ───────────────────────────────────────────────────────────────────
    function resetAllClearThePageInfo() {
        if (mode === 'edit') {
            setCronExp(initialFrequency);
            setTimeZoneValue((prev) => ({ value: initialTimeZone || prev?.value }));
            setMinuteValue(cronMinuteValueLoad);
            setHourValue(cronHourValueLoad);
            setDayValue(cronDayValueLoad);
            setMonthValue(cronMonthValueLoad);
            setWeekValue(cronWeekValueLoad);
            reset({ frequency: initialFrequency, timeZone: initialTimeZone || timeZoneValue?.value });
        } else {
            setCronExp('* * * * *');
            setTimeZoneValue((prev) => ({ value: initialTimeZone || prev?.value }));
            setMinuteValue([]);
            setHourValue([]);
            setDayValue([]);
            setMonthValue([]);
            setWeekValue([]);
            reset({ frequency: initialFrequency, timeZone: initialTimeZone || timeZoneValue?.value });
        }
    }

    // ─── Close ───────────────────────────────────────────────────────────────────
    const handleClose = (value) => {
        resetAllClearThePageInfo();
        onClose(value);
    };

    // ─── Submit ──────────────────────────────────────────────────────────────────
    const apiUrlAndParamBodyConstants = GlobalEdiApiConstants();

    const onSubmit = () => {
        const id = emailMessageConfigToBeEdited?.custValConfigId;
        const timeZone = timeZoneValue.value;
        let payload = { id, frequency: cronExp, active: isActive, timeZone: timeZone };


        const apiUrl = apiUrlAndParamBodyConstants.commonApiUrlForAllTheScreen.customsValuationEmailMsgConfig;
        let endpoint = "";
        if (frequencyType === 'alertEmail') {
            endpoint = `${apiUrl}/alertFrequency`;
        } else if (frequencyType === 'evaluationConfirmationEmail') {
            endpoint = `${apiUrl}/evaluationFrequency`;
        }

        if (endpoint) {
            setIsSubmitting(true);          // ✅ show spinner
            CommonService.saveOrUpdateOrPost(endpoint, payload)
                .then((response) => {
                    if (onSchedulerSave) {
                        onSchedulerSave(frequencyType, cronExp, timeZone);

                    }
                   const successMsg =
                    typeof response?.data === 'string'
                        ? response.data
                        : response?.data?.message || 'Scheduler configuration saved successfully';

                    setIsSubmitting(false); // ✅ hide spinner
                    setAlertBoxState({
                        ...alertBoxState,
                        openAlert: true,
                        message: successMsg,
                        severity: 'success',
                    });
                    setTimeout(() => {onClose(true);}, 1000);
                })
                .catch((error) => {
                    // ✅ Safely extract a string from error response
                    const errorMsg =
                        typeof error?.response?.data === 'string'
                            ? error.response.data
                            : error?.response?.data?.message || 'Failed to save scheduler configuration';
                    setIsSubmitting(false); // ✅ hide spinner on error too
                    setSaveOrUpdateButtonDisabled(false);
                    setAlertBoxState({
                        ...alertBoxState,
                        openAlert: true,
                        message: errorMsg,
                        severity: 'error',
                    });
                });
        }
    };

    const onError = () => {
        setAlertBoxState({
            ...alertBoxState, openAlert: true, message: 'Form has errors', severity: 'error',
        });
    };

    // ─── Combo properties ────────────────────────────────────────────────────────
    const timeZoneComboProperty = {
        name: pageLabelsConstantsAndMessages.name.timeZone,
        isRequired: false,
        label: intl.formatMessage({ id: 'customschedulartab.timezone.label', defaultMessage: 'Time Zone' }),
        isAutofocus: false,
        variant: 'outlined',
        isHookFormType: true,
        isDisabled: disabledForReadMode,
    };

    return (
        <React.Fragment>
            <CssBaseline />
            <Grid container className={classes.root}>
                <Grid item container justifyContent="center" alignItems="center" xs={12}>
                    <Dialog fullWidth maxWidth="lg" aria-labelledby="scheduler-dialog" open={open}>

                        <Snackbar
                            anchorOrigin={{ vertical, horizontal }}
                            open={openAlert}
                            onClose={handleCloseAlert}
                            key={vertical + horizontal}
                            autoHideDuration={6000}
                        >
                            <Alert onClose={handleCloseAlert} severity={severity}>{message}</Alert>
                        </Snackbar>

                        <DialogTitle className={classes.titleCommonDialogComponent}>
                            <Grid item container xs={12}>
                                <Grid item container alignItems="center" xs={12} sm={6} style={{ marginLeft: '-0.8%' }}>
                                    <CustomBreadCrumb componentList={componentList} isDialog={true} />
                                </Grid>
                            </Grid>
                        </DialogTitle>

                        <DialogContent style={{ minHeight: '60vh' }}>
                            {isSubmitting && (
                                <Grid
                                    container
                                    justifyContent="center"
                                    alignItems="center"
                                    style={{
                                        position: 'absolute',
                                        top: 0, left: 0,
                                        width: '100%', height: '100%',
                                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                        zIndex: 9999,
                                    }}
                                >
                                    <Grid item style={{ textAlign: 'center' }}>
                                        <CircularProgress size={50} color="primary" />
                                        <Typography style={{ marginTop: '10px', fontWeight: 'bold', color: '#1976d2' }}>
                                            <FormattedMessage id="common.button.processing" defaultMessage="Processing..." />
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                            <Grid container className={classes.root}>
                                <Grid item container xs={12} className={classes.textfieldSpacing}>
                                    <Grid item container xs={12} spacing={2} className={classes.gridSpacing}>

                                        {/* ── Time Zone ── */}
                                        <Grid item container xs={12} sm={6} md={6} lg={6}>
                                            <TimeZoneCombo
                                                comboProperty={timeZoneComboProperty}
                                                control={control}
                                                comboValue={timeZoneValue}
                                                setComboValue={setTimeZoneValue}
                                            />
                                        </Grid>

                                        {/* ── Cron Indicator (read-only display) ── */}
                                        <Grid item container xs={12} sm={6} md={6} lg={6}>
                                            <FormControl fullWidth>
                                                <Controller
                                                    control={control}
                                                    name={pageLabelsConstantsAndMessages.name.frequency}
                                                    render={({ field }) => (
                                                        <TextField
                                                            className={classes.textField}
                                                            {...field}
                                                            size="small"
                                                            variant="outlined"
                                                            label={
                                                                <FormattedMessage
                                                                    id="customschedulartab.indicator.label"
                                                                    defaultMessage="Cron Expression"
                                                                />
                                                            }
                                                            InputLabelProps={{ shrink: true }}
                                                            InputProps={{ readOnly: true }}
                                                            value={cronExp}
                                                            disabled={disabledForReadMode}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                            <FormHelperText>
                                                <FormattedMessage
                                                    id="textfield.indicator.message"
                                                    defaultMessage="Auto-generated from selections below"
                                                />
                                            </FormHelperText>
                                        </Grid>

                                        {/* ── Human-readable schedule ── */}
                                        <Grid item container xs={12}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    className={classes.textField}
                                                    size="small"
                                                    variant="outlined"
                                                    label={
                                                        <FormattedMessage
                                                            id="customschedulartab.currentstate.label"
                                                            defaultMessage="Schedule Description"
                                                        />
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{ readOnly: true }}
                                                    value={currentState}
                                                    disabled={disabledForReadMode}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>

                                    <Divider variant="middle" style={{ height: '3px', width: '98%', margin: '10px 10px' }} />

                                    {/* ── Cron selectors ── */}
                                    <Grid item container xs={12} spacing={2} className={classes.gridSpacing}>

                                        {/* Minute */}
                                        <Grid item container xs={12} sm={6} md={4} lg={4}>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    multiple size="small" id="selectMinute"
                                                    limitTags={checked ? 1 : -1}
                                                    options={everyMinuteValue}
                                                    filterSelectedOptions
                                                    onChange={handleChangeForMinuteCron}
                                                    getOptionLabel={(option) => option.value}
                                                    value={minuteValue}
                                                    defaultValue={cronMinuteValueLoad}
                                                    disabled={disabledForReadMode}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params} variant="outlined"
                                                            label={intl.formatMessage({ id: 'customschedulartab.everyMinute.label', defaultMessage: 'Minute' })}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>

                                        {/* Hour */}
                                        <Grid item container xs={12} sm={6} md={4} lg={4}>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    multiple size="small" id="selectHours"
                                                    limitTags={checked ? 1 : -1}
                                                    options={everyHourValue}
                                                    filterSelectedOptions
                                                    onChange={handleChangeForHourCron}
                                                    getOptionLabel={(option) => option.value}
                                                    value={hourValue}
                                                    defaultValue={cronHourValueLoad}
                                                    disabled={disabledForReadMode}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params} variant="outlined"
                                                            label={intl.formatMessage({ id: 'customschedulartab.everyHour.label', defaultMessage: 'Hour' })}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>

                                        {/* Day of Month */}
                                        <Grid item container xs={12} sm={6} md={4} lg={4}>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    multiple size="small" id="selectDay"
                                                    limitTags={checked ? 1 : -1}
                                                    options={everyDayValue}
                                                    filterSelectedOptions
                                                    onChange={handleChangeForDayCron}
                                                    getOptionLabel={(option) => option.value}
                                                    value={dayValue}
                                                    defaultValue={cronDayValueLoad}
                                                    disabled={isCronDayFieldDisable || disabledForReadMode}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params} variant="outlined"
                                                            label={intl.formatMessage({ id: 'customschedulartab.everyDay.label', defaultMessage: 'Day of Month' })}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>

                                        {/* Month */}
                                        <Grid item container xs={12} sm={6} md={4} lg={4}>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    multiple size="small" id="selectMonth"
                                                    limitTags={checked ? 1 : -1}
                                                    options={everyMonthValue}
                                                    filterSelectedOptions
                                                    onChange={handleChangeForMonthCron}
                                                    getOptionLabel={(option) => option.value}
                                                    value={monthValue}
                                                    defaultValue={cronMonthValueLoad}
                                                    disabled={disabledForReadMode}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params} variant="outlined"
                                                            label={intl.formatMessage({ id: 'customschedulartab.selectmonth.label', defaultMessage: 'Month' })}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>

                                        {/* Day of Week */}
                                        <Grid item container xs={12} sm={6} md={4} lg={4}>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    multiple size="small" id="selectWeek"
                                                    limitTags={checked ? 1 : -1}
                                                    options={everyWeekValue}
                                                    filterSelectedOptions
                                                    onChange={handleChangeForWeekCron}
                                                    getOptionLabel={(option) => option.value}
                                                    value={weekValue}
                                                    defaultValue={cronWeekValueLoad}
                                                    disabled={isWeekDayFieldDisable || disabledForReadMode}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params} variant="outlined"
                                                            label={intl.formatMessage({ id: 'customschedulartab.everyDayOfWeek.label', defaultMessage: 'Day of Week' })}
                                                            InputLabelProps={{ shrink: true }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>

                                        {/* Limit Tags toggle */}
                                        <Grid item container xs={12} sm={6} md={4} lg={4}>
                                            <Grid container justifyContent="flex-start" alignItems="center">
                                                <Checkbox color="primary" onChange={handleChange} checked={checked} />
                                                <InputLabel>
                                                    <FormattedMessage id="customschedulartab.limittags.label" defaultMessage="Limit Tags" />
                                                </InputLabel>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={3} lg={3}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        color="primary"
                                                        checked={isActive}
                                                        onChange={(e) => setIsActive(e.target.checked)}
                                                        disabled={mode === 'read'}
                                                    />
                                                }
                                                label="Active"
                                            />
                                        </Grid>


                                    </Grid>
                                </Grid>
                            </Grid>
                        </DialogContent>

                        {/* ── Desktop actions ── */}
                        {!smallScreen && (
                            <DialogActions>
                                <Grid container justifyContent="flex-start" alignItems="center" item xs={12} className={classes.textfieldSpacing}>
                                    {mode !== 'read' && <InfoIcon color="primary" />}
                                    {mode !== 'read' && (
                                        <Typography style={{ fontSize: 12, marginLeft: '1%' }}>
                                            <FormattedMessage
                                                id="textfield.placeholder.dialogActions"
                                                defaultMessage="Configure the cron schedule using the selectors above"
                                            />
                                        </Typography>
                                    )}
                                </Grid>
                                <Grid container justifyContent="flex-end" alignItems="center" item xs={12} className={classes.commonDialogButtonSpacing}>
                                    <Button
                                        size="small" variant="contained" color="primary"
                                        className={classes.stateButtonForBack} elevation={2}
                                        endIcon={<ClearIcon />}
                                        onClick={() => handleClose(false)}
                                    >
                                        <FormattedMessage id="common.button.cancel.lable" defaultMessage="Cancel" />
                                    </Button>
                                    <Button
                                        size="small" variant="contained" color="secondary"
                                        className={classes.stateButtonToRestore} elevation={2}
                                        disabled={disableRestoreButton}
                                        endIcon={<IconRestore />}
                                        onClick={resetAllClearThePageInfo}
                                    >
                                        <FormattedMessage id="common.button.reset.lable" defaultMessage="Reset" />
                                    </Button>
                                    {mode !== 'read' && (
                                        <Button
                                            size="small" variant="contained" color="primary"
                                            className={classes.stateButtonForSave} elevation={2}
                                            disabled={disableSaveOrUpdateButton && !isSubmitting} // ✅ allow render when submitting
                                            endIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : <IconSaveOrUpdate />}
                                            onClick={!isSubmitting ? handleSubmit(onSubmit, onError) : undefined} // ✅ block double click
                                        >
                                            {isSubmitting 
                                                ? <FormattedMessage id="common.button.processing" defaultMessage="Processing..." />
                                                : saveOrUpdateButtonLabel
                                            }
                                        </Button>
                                    )}
                                </Grid>
                            </DialogActions>
                        )}

                        {/* ── Mobile actions ── */}
                        {smallScreen && (
                            <DialogActions>
                                <Grid container justifyContent="center" alignItems="center" item xs={12}>
                                    <Tooltip title={<FormattedMessage id="common.button.cancel.lable" defaultMessage="Cancel" />}>
                                        <Button size="small" variant="contained" color="primary"
                                            className={classes.stateButtonForBack} elevation={2}
                                            onClick={() => handleClose(false)}
                                        >
                                            <ClearIcon />
                                        </Button>
                                    </Tooltip>
                                    <Tooltip title={<FormattedMessage id="common.button.reset.lable" defaultMessage="Reset" />}>
                                        <Button size="small" variant="contained" color="secondary"
                                            className={classes.stateButtonToRestore} elevation={2}
                                            disabled={disableRestoreButton}
                                            onClick={resetAllClearThePageInfo}
                                        >
                                            <IconRestore />
                                        </Button>
                                    </Tooltip>
                                    {mode !== 'read' && (
                                        <Tooltip title={mode === 'create'
                                            ? <FormattedMessage id="common.button.save" defaultMessage="Save" />
                                            : <FormattedMessage id="common.button.update" defaultMessage="Update" />
                                        }>
                                            <Button size="small" variant="contained" color="primary"
                                                className={classes.stateButtonForSave} elevation={2}
                                                disabled={disableSaveOrUpdateButton}
                                                onClick={handleSubmit(onSubmit, onError)}
                                            >
                                            {isSubmitting ? <CircularProgress size={20} color="inherit" /> : <IconSaveOrUpdate />}
                                            </Button>
                                        </Tooltip>
                                    )}
                                </Grid>
                            </DialogActions>
                        )}

                    </Dialog>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default CustomValuationSchedulerTab;